import { configureStore, combineReducers, getDefaultMiddleware } from "@reduxjs/toolkit";
import capitalReducer from "reducers/portfolio/capital";
import stockReducer from "reducers/portfolio/stock";
import userReducer from "reducers/user";
import etcReducer from "reducers/etc";

const combinedReducer = combineReducers({
	userCapital: capitalReducer,
	userStock: stockReducer,
	user: userReducer,
	etc: etcReducer,
});

const rootReducer = (state, action) => {
	if (action.type === "user/logout") {
		state = undefined;
	}
	return combinedReducer(state, action);
};

export const store = configureStore({
	reducer: rootReducer,
});
